import { ICreditsState } from 'store/types/credit'

export const getInitialState = (): ICreditsState => ({
  featureOperationCosts: null,
  userCredits: null
})
